// Global Types
import type {
  $GeoLocation,
} from 'common.types';

// Global Components
import * as React from 'react';
import {
  Polygon,
} from '@react-google-maps/api';

// Helpers
import {
  isDiff,
} from '@vroskus/library-helpers/dist/browser';

// Types
type $Props = {
  active: boolean;
  onClick: (flag: string) => unknown;
  region: {
    center: $GeoLocation;
    flag: string;
    path: Array<Array<$GeoLocation>>;
    zoom: number;
  };
};

type $Options = {
  clickable: boolean;
  draggable: boolean;
  editable: boolean;
  fillColor: string;
  fillOpacity: number;
  geodesic: boolean;
  strokeColor: string;
  strokeOpacity: number;
  strokeWeight: number;
  zIndex: number;
};

type $State = {
  options: $Options;
};

class MapRegionView extends React.Component<$Props, $State> {
  constructor(props: $Props) {
    super(props);

    this.state = {
      options: this.getOptions(),
    };
  }

  componentDidUpdate(prevProps: $Props): void {
    const {
      active,
    } = this.props;

    if (isDiff(
      active,
      prevProps.active,
    )) {
      this.setState({
        options: this.getOptions(),
      });
    }
  }

  getOptions(): $Options {
    const {
      active,
    } = this.props;

    const commonOptions = {
      draggable: false,
      editable: false,
      fillColor: 'rgb(20, 83, 136)',
      geodesic: false,
      strokeOpacity: 1,
      strokeWeight: 2,
    };

    return (active === true ? {
      ...commonOptions,
      clickable: false,
      fillOpacity: 0,
      strokeColor: 'rgb(22, 163, 74)',
      zIndex: 2,
    } : {
      ...commonOptions,
      clickable: true,
      fillOpacity: 0.1,
      strokeColor: 'rgb(20, 83, 136)',
      zIndex: 1,
    });
  }

  render() {
    const {
      active,
      onClick,
      region,
    } = this.props;
    const {
      options,
    } = this.state;

    return (
      <Polygon
        key={region.flag}
        onClick={() => onClick(region.flag)}
        onMouseOut={() => !active && this.setState({
          options: {
            ...options,
            fillOpacity: 0.1,
          },
        })}
        onMouseOver={() => !active && this.setState({
          options: {
            ...options,
            fillOpacity: 0.3,
          },
        })}
        options={options}
        paths={region.path}
      />
    );
  }
}

export default MapRegionView;
